class ShowMoreTable {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.items = self.elem.querySelectorAll('[data-item]');
        self.btn = self.elem.querySelector('[data-btn]');
        self.btnLess = self.elem.querySelector('[data-btn-less]');
    }

    init() {
        let self = this;

        self.showMore();
        self.showLess();
    }

    showMore() {
        let self = this;
        let loop = [];

        self.items.forEach((item) => {
            if (item.classList.contains('d-none')) {
                loop.push(item);
            }
        });

        self.btn.addEventListener('click', function() {
            let newloop = [];

            self.items.forEach((item) => {
                if (item.classList.contains('d-none')) {
                    newloop.push(item);
                }
            });

            newloop.forEach((lop, i) => {
                if (8 > i) {
                    lop.classList.remove('d-none');
                }
            });

            self.items.forEach((item) => {
                if (item.classList.contains('d-none')) {
                    newloop.push(item);
                }
            });

            if (newloop.length <= 8) {
                self.btn.classList.add('d-none');
            }

            self.btnLess.classList.remove('d-none');
        });
    }

    showLess() {
        let self = this;

        self.btnLess.addEventListener('click', function() {
            self.btn.classList.remove('d-none');

            self.items.forEach((item, i) => {
                if (i < 8) {
                    item.classList.remove('d-none');
                } else {
                    item.classList.add('d-none');
                }
            });

            self.btnLess.classList.add('d-none');
        });
    }
}

export default ShowMoreTable;
